import React, { useState } from 'react'

import {
  Grid,
  Typography,
  Button,
  TextField,
  CircularProgress
} from '@mui/material'
import { useApi } from '../../../hooks/useApi'
import axios from 'axios'
import { ApiConfig } from '../../../config/api'
import { Status } from '../../../hooks/useFetchState'
import SaveIcon from '@mui/icons-material/Save'

interface ChangeWorkOrderTagComponentProps {
  loading?: boolean
  actualTag: string
  workOrderIds: number[]
  openSnackBar: (msg: string | undefined, status: boolean) => void
}

export const patchWorkOrder = (workOrderIds: number[], newTag: string) => {
  const url = new URL(`${ApiConfig.WorkOrderTagApi}`)
  return axios.patch(url.toString(), {
    workOrderIds,
    newTag
  })
}

export const ChangeWorkOrderTagComponent: React.FC<ChangeWorkOrderTagComponentProps> =
  ({ workOrderIds, actualTag, loading = false, openSnackBar }) => {
    const [newTag, setNewTag] = useState(actualTag)

    const { state, callApi } = useApi()

    const requestSetNewTagWorkOrder = () => {
      callApi(patchWorkOrder(workOrderIds, newTag.trim()))
        .then(() => {
          
          setNewTag(newTag.trim());
          openSnackBar('Tag actualizado correctamente', true)})
        .catch((err) => openSnackBar(err, false))
    }

    const isLoading = state.status === Status.Loading || loading

    return (
      <Grid container direction='row' item xs={12} spacing={3}>
        <Grid item xs={12} sm={4}>
          <Typography>Modificar Tag</Typography>
        </Grid>
        <Grid item xs={12} sm={4}>
          <TextField
            fullWidth
            variant='outlined'
            value={newTag}
            onChange={(e) => {
                setNewTag(e.target.value);
            }}
            disabled={isLoading}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <Button
            disabled={isLoading || newTag === actualTag || newTag.trim().length <= 1}
            variant='contained'
            color='primary'
            onClick={requestSetNewTagWorkOrder}
            endIcon={isLoading ? <CircularProgress size={'14px'} /> : <SaveIcon/>}
          >
          </Button>
        </Grid>
      </Grid>
    )
  }
